import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, CURRENT_ENV } from '../../../../utils';
import {
  APP_ID,
  APP_VERSION,
} from '../../../../utils/constants/request-related';
let bucketName = '';
const prodEnvEnums = [
  'STAGING',
  'PRODUCTION',
  'GOOGLE-SPOT-PREPROD',
  'GOOGLE-SPOT-PROD',
];
if (prodEnvEnums.includes(CURRENT_ENV)) {
  bucketName = `esdoc`;
} else {
  bucketName = `esqadoc-qa`;
}

export const ITR_s3FileUpload_API_CALL = createAsyncThunk(
  'ITR_s3FileUpload_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'ITR_s3FileUpload_API_CALL/pending', payload: {} });
    const { payload: s3SaveFilePayload, successFn, errorFn } = payload;
    const {
      Authorization,
      customerId,
      customerRefNum,
      folder_name,
      file_name,
      inputStream,
      index = 3,
    } = s3SaveFilePayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      route: 'customerkyc/s3savefilenew',
      payload: {
        customerRefNum,
        s3SaveFileDetails: {
          bucket_name: bucketName,
          folder_name,
          file_name,
          inputStream,
        },
        // content_type: 'application/pdf',
      },
      otherPayloadDetailsPresent: true,
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const s3SaveFileResponse = res;
        dispatch({
          type: 'ITR_s3FileUpload_API_CALL/fulfilled',
          payload: { response: s3SaveFileResponse, index },
        });
        if (successFn) successFn(s3SaveFileResponse);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        if (errorFn) errorFn(err);
        dispatch({ type: 'ITR_s3FileUpload_API_CALL/rejected', payload: err });
      },
    });
  }
);

export const ITR_s3FileUpload_API_CALL_extrareducer = {
  [ITR_s3FileUpload_API_CALL.pending]: (state, action) => {
    state.s3FileUploadAPICall.isLoading = true;
  },
  [ITR_s3FileUpload_API_CALL.fulfilled]: (state, action) => {
    state.s3FileUploadAPICall.isLoading = false;

    state.s3FileUploadAPICall.isSuccess = true;
    state.s3FileUploadAPICall.isError = false;
    if (action.payload) {
      const { response, index } = action.payload;

      state.s3FileUploadAPICall.response = response;
      state.s3FileUploadAPICall.uploadFileResponses[index] = response;
    }
  },
  [ITR_s3FileUpload_API_CALL.rejected]: (state, action) => {
    state.s3FileUploadAPICall.isLoading = false;

    state.s3FileUploadAPICall.isSuccess = false;
    state.s3FileUploadAPICall.isError = true;
    state.s3FileUploadAPICall.response = action.payload;
  },
};
